export default {
  data () {
    return {
      // Lost & Found Form
      formLostItem: {
        student_name: '',
        student_id: '',
        contact_number: '',
        category: '',
        location: '',
        description: '',
        date_lost: '',
        image: null
      },

      // Options for forms
      options: {
        itemCategories: [
          { id: 'electronics', name: 'Electronics (Phone, Laptop, etc.)' },
          { id: 'accessories', name: 'Accessories (Watch, Jewelry, etc.)' },
          { id: 'documents', name: 'Documents (ID, Books, etc.)' },
          { id: 'clothing', name: 'Clothing & Bags' },
          { id: 'others', name: 'Others' }
        ],
        locations: [
          { id: 'main_building', name: 'Main Building' },
          { id: 'library', name: 'Library' },
          { id: 'cafeteria', name: 'Cafeteria' },
          { id: 'gym', name: 'Gymnasium' },
          { id: 'grounds', name: 'Campus Grounds' },
          { id: 'parking', name: 'Parking Area' },
          { id: 'others', name: 'Others' }
        ]
      }
    }
  },

  methods: {
    resetLostItemForm () {
      this.formLostItem = {
        student_name: '',
        student_id: '',
        contact_number: '',
        category: '',
        location: '',
        description: '',
        date_lost: '',
        image: null
      }
    },

    validateLostItemForm () {
      const required = ['student_name', 'student_id', 'contact_number', 'location', 'description']
      const missing = required.filter(field => !this.formLostItem[field])

      if (missing.length > 0) {
        this.$bvToast.toast('Please fill in all required fields', {
          title: 'Validation Error',
          variant: 'warning',
          solid: true
        })
        return false
      }

      return true
    }
  }
}
